module.exports = __webpack_public_path__ + "img/hand-shake_1280.577baee6.jpg";